module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1019.03fd7f4b.png";